import api, { IDataRequest, IDataResponse } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";
import qs from 'qs';

export interface ConcessionariaItem {
    id: number
    estado_id: string
    agente: string
    distribuidora: string
    distribuidora_cnpj: string
    agente_componente: string
    fim_vigencia: string
    subgrupo: string
    modalidade_tarifaria: string
    detalhe: string
    posto_tarifario: string
    unidade_terciaria: string
    valor_tusd: number
    valor_te: number
    valor_tusd_fio_b: number
    valor_tusd_fio_a: number
    created_at: string
    updated_at: string
    user_guilted_id: number
}

class ConcessionariasProvider extends AProvider {
    constructor() {
        super("/cadastros/concessionarias");
    }

    async buscarConcessionariasPorEstado(estado_id: string): Promise<ConcessionariaItem[]> {
        const qString = { orderby: 'distribuidora'}

        if (estado_id) Object.assign(qString, { estado_id: estado_id })
        
        const queryString = qs.stringify(qString).toString()
        const url = `${this.path}?${queryString}`

        const request: IDataRequest = { url }
        const response: IDataResponse<ConcessionariaItem[]> = await api.get(request);
        return response.data
    }
}

export { ConcessionariasProvider }